import React, { useEffect } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { Grid } from '@material-ui/core';

const ReportGraphVerticalBar = ({ title, dataPeriodoGeral, fontFamily }) => {
	const hasData = dataPeriodoGeral && dataPeriodoGeral.length > 0;
	const categories = [];
	const seriesData = [];
	const links = [];

	const colors = ['#6DA2F4', '#9F18DE', '#FA9940', '#3DAC4C'];

	if (hasData) {
		const categoryMap = {};
		for (let i = 0; i < dataPeriodoGeral.length; i++) {
			const result = dataPeriodoGeral[i];
			const periodo_nome = result.periodo_nome;
			const quantidade_usos = result.quantidade_usos;


			const normalizedName = periodo_nome
				.toLowerCase()
				.replace(/ /g, '')
				.normalize('NFD')
				.replace(/[\u0300-\u036f]/g, '');


			if (categoryMap[normalizedName]) {

				categoryMap[normalizedName].quantidade_usos += quantidade_usos;
			} else {

				categoryMap[normalizedName] = {
					periodo_nome: periodo_nome,
					quantidade_usos: quantidade_usos,
				};
			}

			let link;
			switch (normalizedName) {
				case 'ensinofundamentali':
					link = 'report-plan-periodo/1';
					break;
				case 'ensinofundamentalii':
					link = 'report-plan-periodo/2';
					break;
				case 'ensinomedio/novoensinomedio':
					link = 'report-plan-periodo/3';
					break;
				default:
					link = 'report-plan-periodo/0';
			}

			links.push(link);
		}

		for (const key in categoryMap) {
			if (categoryMap.hasOwnProperty(key)) {
				const category = categoryMap[key];
				categories.push(category.periodo_nome);
				seriesData.push({
					name: category.periodo_nome,
					data: [category.quantidade_usos],
					color: colors[seriesData.length],
				});
			}
		}
	}
	const options = {
		chart: {
			type: 'bar',
		},
		title: {
			text: title,
			align: 'center',
			style: {
				fontFamily: fontFamily,
			},
		},
		xAxis: {
			title: {
				text: 'Etapa de Ensino',
				style: {
					fontFamily: fontFamily,
				},
			},
			categories: categories,
			gridLineWidth: 0,
			labels: {
				style: {
					fontFamily: fontFamily,
				},
			},
		},
		yAxis: {
			title: {
				text: 'Valores',
				style: {
					fontFamily: fontFamily,
				},
			},
			gridLineWidth: 0,
			labels: {
				style: {
					fontFamily: fontFamily,
				},
			},
		},
		plotOptions: {
			bar: {
				dataLabels: {
					enabled: true,
					style: {
						fontFamily: fontFamily,
					},
				},
				pointWidth: 20,
			},
			series: {
				events: {
					legendItemClick: function () {

						const link = links[this.index];
						if (link) {
							window.location.href = link;
						}
					},
				},
			},
		},
		series: seriesData,
		legend: {
			enabled: true,
			align: 'right',
			layout: 'vertical',
			y: -200,
			itemMarginBottom: 10,
			style: {
				fontFamily: fontFamily,
			},
		},
	};

	return (
		<>
			<Grid item xs={12}>
				<label
					style={{
						fontFamily: 'Public Sans',
						fontWeight: '600',
						fontSize: '18px',
						color: '#262930',
						marginTop: '36px',
						marginBottom: '16px',
					}}
				>
					Comparativo de Planos de Aprendizagem gerados por Etapa de Ensino
				</label>
			</Grid>
			<div style={{ height: '400px' }}>
				<HighchartsReact highcharts={Highcharts} options={options} />
			</div>
		</>
	);
};

export default ReportGraphVerticalBar;
